import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import dateFormat from 'dateformat';
import { getOrderDetailsByOrderId } from "../../redux/actions/order_actions";
import CartBlock from '../CartBlock/CartBlock';
import Swal from 'sweetalert2';
import {
  Button,
  Modal,
  Input,
  NavLink
} from "reactstrap";

const CardOrder = ({ ...props }) => {
  const renderCardImage = (image) => {
    if (image) {
      return image;
    } else {
      return "";
    }
  };
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  })

  // Handle toogle Modal
  const [modal, setModal] = React.useState(false);
  const toggleModal = () => {
    setModal(!modal);
    // Handle Data
    props.dispatch(getOrderDetailsByOrderId(props.orderId))
  };

  const handleNavigate = () => {
    props.history.push(`/product-rating/${props.orderId}`)
  }

  const renderOrderInfo = () => {
    if(props.order.orderDetailsByOrderId && props.order.orderDetailsByOrderId.orderDetailsByOrderId){
      return(
        <CartBlock
          list={props.order.orderDetailsByOrderId.orderDetailsByOrderId}
          type="orderdetails"
          title="orderdetails" />
      )
    }
  }

  return (
      <>
      <div className="row" id="webOrderDetail" style={{ paddingLeft:0, paddingRight:0, marginRight:15, marginLeft:15 }}>
          <div className="col-md-2 text-left p-0">
            <h6>#{props.orderId}</h6>
          </div>
          <div className="col-md-3 text-left">
            <b>{dateFormat(props.orderDate, "dd/mm/yyyy hh:mm")}</b>
          </div>
          <div className="col-md-2 text-center">
            <b>{props.status}</b>
          </div>
          <div className="col-md-3 text-left" style={{ paddingLeft:90 }}>
            <b style={{ fontSize:16 }}>{ formatter.format(props.total) }</b>
          </div>
          <div className="col-md-2 text-center">
            <a className="infoOrder" onClick={toggleModal} style={{ fontSize:20 }}><i className="fas fa-chevron-circle-down"></i></a> 
          </div>
      </div>
      <div className="row" id="mobileOrderDetail" style={{ paddingLeft:0, paddingRight:0, marginRight:15, marginLeft:15 }}>
          <div className="col-xs-8">
            <div>
              Mã đơn hàng: <b>#{props.orderId}</b>
              <br />
              Ngày đặt hàng: <b>{dateFormat(props.orderDate, "dd/mm/yyyy")}</b>
              <br />
              Ghi chú: <b>{props.status}</b>
              <br />
              Tổng tiền: <b style={{ fontSize:16 }}>{ formatter.format(props.total) }</b>
              <br />
            </div>
          </div>          
          <div className="col-xs-4 text-center">
            <a className="infoOrder" onClick={toggleModal} style={{ fontSize:20, marginTop:"500px" }}><i className="fas fa-chevron-circle-down"></i></a> 
          </div>
      </div>
      <hr className="divider" />
      
      <Modal isOpen={modal} toggle={toggleModal} dialogClassName="modalDialog">
        <div className="modal-header">
          <button
            aria-label="Close"
            className="close"
            type="button"
            onClick={toggleModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
          <h5
            className="modal-title text-center"
            id="exampleModalLabel"
          >
            Chi Tiết Đơn Hàng
          </h5>
        </div>
        <div className="modal-body">
          <div className="row justify-content-center">
            <div className="container-fluid p-0">
              {renderOrderInfo()}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="left-side">
              <Button
                className="btn-link"
                color="default"
                type="button"
                onClick={handleNavigate}
              >
                Đánh Giá Sản Phẩm
              </Button>
          </div>
          <div className="divider" />
          <div className="right-side">
            <Button
              className="btn-link"
              color="default"
              type="button"
              onClick={toggleModal}
            >
              Đóng
            </Button>
          </div>
        </div>
      </Modal>
      </>
  );
};

const mapStateToProps = (state) => {
  return {
      order: state.order,
  };
};

export default connect(mapStateToProps)(withRouter(CardOrder));